export default [
  {
    header: 'Preop',
    icon: 'GridIcon',
    route: 'preop',
    title: 'Preop'
  },
]
